import { render, staticRenderFns } from "./DialogPreviewFile.vue?vue&type=template&id=fd63e53a&scoped=true&"
import script from "./DialogPreviewFile.vue?vue&type=script&lang=js&"
export * from "./DialogPreviewFile.vue?vue&type=script&lang=js&"
import style0 from "./DialogPreviewFile.vue?vue&type=style&index=0&id=fd63e53a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd63e53a",
  null
  
)

export default component.exports